import { z } from 'zod'
import { apiEnvelope, pageSchema } from '@/shared/api/api-contract'

export const authTokenEnvelopeSchema = apiEnvelope(z.object({ token: z.string().min(1) }))

export const memberRegistrationEnvelopeSchema = apiEnvelope(z.object({
  enabled: z.boolean(),
}))

export const memberSchema = z.object({
  memberUserId: z.number().int(),
  email: z.string(),
  nickname: z.string().nullish(),
  avatarFileId: z.number().int().nullish(),
  avatarPreviewUrl: z.string().nullish(),
  mustChangePassword: z.boolean().default(false),
})

export const memberEnvelopeSchema = apiEnvelope(memberSchema)

export const pointBalanceSchema = z.object({
  memberUserId: z.number().int(),
  balance: z.number().int(),
  frozenBalance: z.number().int(),
  totalBalance: z.number().int(),
  updatedAt: z.string(),
})

export const pointBalanceEnvelopeSchema = apiEnvelope(pointBalanceSchema)

export const pointTransactionSchema = z.object({
  id: z.number().int(),
  transactionType: z.enum(['ADMIN_GRANT', 'ADMIN_DEDUCT', 'AI_CONSUME']),
  transactionTypeName: z.string(),
  direction: z.enum(['INCOME', 'EXPENSE']),
  directionName: z.string(),
  changeAmount: z.number().int(),
  balanceAfter: z.number().int(),
  businessType: z.string().nullish(),
  businessId: z.string().nullish(),
  description: z.string(),
  createdAt: z.string(),
})

export const pointTransactionsEnvelopeSchema = apiEnvelope(pageSchema(pointTransactionSchema))

export const fileQuotaSchema = z.object({
  quotaBytes: z.number().int(),
  usedBytes: z.number().int(),
  pendingBytes: z.number().int(),
  occupiedBytes: z.number().int(),
  availableBytes: z.number().int(),
  overQuotaBytes: z.number().int(),
  overQuota: z.boolean(),
})

export const fileQuotaEnvelopeSchema = apiEnvelope(fileQuotaSchema)

export type Member = z.infer<typeof memberSchema>
export type PointBalance = z.infer<typeof pointBalanceSchema>
export type FileQuota = z.infer<typeof fileQuotaSchema>
